import Vue from 'vue'
import App from './App.vue'
import store from "./store";

// //  系统的名字改一下
// Vue.prototype.appName = "门头沟文化管理系统";
// Vue.prototype.appNameEnglish = "A WebGIS System for MenTouGou";


import "../static/css/bootstrap-3.3.7-dist/css/bootstrap.min.css"
Vue.config.productionTip = false

import "./assets/font-awesome-4.7.0/css/font-awesome.min.css"

import axios from 'axios'
Vue.prototype.$axios = axios;

import router from "./router";

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import uploader from 'vue-simple-uploader'
Vue.use(uploader)

import xxMap from './components/2DMap/map/xxMap.js';
Vue.prototype.xxMap = xxMap;


import animated from 'animate.css'
Vue.use(animated)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')